/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FormElementEventType {
    SUM_TO = 'SumTo',
    PERCENTAGE_TO = 'PercentageTo',
    CUSTOM_EXPRESSION = 'CustomExpression',
}
